import React from 'react'

function SvgCurrencyDollarIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      fill="none"
      viewBox="0 0 20 20"
    >
      <path
        stroke="#667085"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.667"
        d="M5 13.333a3.333 3.333 0 003.333 3.334h3.334a3.333 3.333 0 100-6.667H8.333a3.333 3.333 0 010-6.667h3.334A3.333 3.333 0 0115 6.667m-5-5v16.666"
      ></path>
    </svg>
  )
}

export default SvgCurrencyDollarIcon
